import React from "react";
import AdminMapeProcesa from "../../components/admin/mapeProcesa";

function AdminMapeProcesaPage(props) {
  return (
    <div className="admin-page-child-wrapper">
      <AdminMapeProcesa />
    </div>
  );
}

export default AdminMapeProcesaPage;
